export enum CalendarViewType {
    month = "month",
    fourWeeks = "4weeks"
}